module.exports = __webpack_public_path__ + "img/horizontal_3_1_1.8c0eea27.png";